export default {
  apiUrl: '/api/details',
  trackBy: 'wine_id',
  detailRowComponentName: 'wine-details-editor',
  dataPath: 'result.rows',
  paginationPath: 'data',
  onEachSide: 1,
  preloadList: [
    {
      name: 'wines',
      target: 'getWineList',
    },
    {
      name: 'details',
      target: 'getDetailList',
    },
    {
      name: 'grapes',
      target: 'getGrapeList',
    },
    {
      name: 'aromas',
      target: 'getAromaList',
    },
  ],
  sortOrder: [{
    field: 'wine_id',
    sortField: 'wine_id',
    direction: 'DESC',
  }],
  paginationTemplate: {
    class: '',
    template: '총 {total}개 중의 {from} 부터 {to}',
  },
  fields: [
    {
      name: '__checkbox',
      titleClass: 'text-center',
      dataClass: 'text-center',
    },
    {
      name: '__slot:actions',
      title: '편집',
      titleClass: 'center aligned',
      dataClass: 'center aligned',
    },
    {
      name: 'wine_id',
      title: '<i style="white-space: nowrap">와인 아이디</i>',
      sortField: 'wine_id',
      titleClass: 'text-center',
      dataClass: 'text-right',
      callback: 'subStringField',
    },
    {
      name: 'wine_full_name',
      title: '<i style="white-space: nowrap">와인 명</i>',
      sortField: 'wine_full_name',
      titleClass: 'text-center',
      dataClass: 'text-right',
      callback: 'subStringField',
    },
    {
      name: 'aroma_names',
      title: '<i style="white-space: nowrap">아로마 이름 목록</i>',
      titleClass: 'text-center',
      dataClass: 'text-right',
      callback: 'subStringField',
    },
    {
      name: 'aromas',
      title: '<i style="white-space: nowrap">아로마 아이디 목록</i>',
      titleClass: 'text-center',
      dataClass: 'text-right',
      callback: 'objectField',
    },
    {
      name: 'grape_names',
      title: '<i style="white-space: nowrap">품종 이름 목록</i>',
      titleClass: 'text-center',
      dataClass: 'text-right',
      callback: 'subStringField',
    },
    {
      name: 'grapes',
      title: '<i style="white-space: nowrap">품종 아이디 목록</i>',
      titleClass: 'text-center',
      dataClass: 'text-right',
      callback: 'subStringField',
    },
    {
      name: 'volume',
      title: '<i style="white-space: nowrap">용량</i>',
      sortField: 'volume',
      titleClass: 'text-center',
      dataClass: 'text-right',
    },
    {
      name: 'abv',
      title: '<i style="white-space: nowrap">알코올</i>',
      sortField: 'abv',
      titleClass: 'text-center',
      dataClass: 'text-right',
    },
    {
      name: 'detail_imgs',
      title: '<i style="white-space: nowrap">디테일 이미지</i>',
      titleClass: 'text-center',
      dataClass: 'text-right',
      callback: 'imgField',
    },
    {
      name: 'img_label',
      title: '<i style="white-space: nowrap">라벨 이미지</i>',
      titleClass: 'text-center',
      dataClass: 'text-right',
      callback: 'imgField',
    },
    {
      name: 'wine_dsc',
      title: '<i style="white-space: nowrap">와인 설명</i>',
      titleClass: 'text-center',
      dataClass: 'text-right',
      callback: 'textField',
    },
    {
      name: 'body',
      title: '<i style="white-space: nowrap">바디감</i>',
      sortField: 'body',
      titleClass: 'text-center',
      dataClass: 'text-right',
    },
    {
      name: 'acidity',
      title: '<i style="white-space: nowrap">신맛</i>',
      sortField: 'acidity',
      titleClass: 'text-center',
      dataClass: 'text-right',
    },
    {
      name: 'tannin',
      title: '<i style="white-space: nowrap">탄닌</i>',
      sortField: 'tannin',
      titleClass: 'text-center',
      dataClass: 'text-right',
    },
    {
      name: 'sweetness',
      title: '<i style="white-space: nowrap">단맛</i>',
      sortField: 'sweetness',
      titleClass: 'text-center',
      dataClass: 'text-right',
    },
    {
      name: '__slot:actions',
      title: '편집',
      titleClass: 'center aligned',
      dataClass: 'center aligned',
    },
  ],
};



// WEBPACK FOOTER //
// ./src/spa/components/board/wine/details/Config.js